import { Component, inject } from "@angular/core";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { Observable } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { DatamanagementDataService } from "@app/datamanagement/services/datamanagement-data.service";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/datamanagement/i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "datamanagement-linkable",
    templateUrl: "./datamanagement-linkable.component.html",
    styleUrls: ["./datamanagement-linkable.component.scss"],
    imports: [LinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class DatamanagementLinkableComponent extends ItemLinkableBase {
    hasAccessChecks = {};
    accessCheckInProgress = false;

    private _dmDataService = inject(DatamanagementDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translation = injectTranslation(scope);
    
    hasAccessToItem(guid: string): Observable<boolean> {
        return this._dmDataService.hasAccess(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.DataManagement,
                item.guid,
                `(P) ${item[this.displayValueProp]}`
            );
        } else {
            // t() needs the scope loaded first; before ready() it throws in development.
            await this._translation.ready();
            this._toastr.warning(
                this._translation.t(
                    "datamanagementLinkable.notEnoughRights"
                )
            );
        }
    }
}
